import { useEffect, useState } from "react";
import intl from "react-intl-universal";
import "./recusa.css";
import TextArea from "components/textarea";
import Button from "components/button";
import { fetchSuggestionsJustifications } from "services/suggestion/suggestion.service";
import { SelectBox } from "components/uikit-adapter/index";
import { IJustification } from "types/justification";
import { IRecusaFornecedorProps } from "./types";

const RecusaFornecedor = ({ handleCancel, idPedido, recusa, refusalAwareness = false }: IRecusaFornecedorProps) => {
  const [observacao, setObservacao] = useState("");
  const [justification, setJustification] = useState<null | number>(null);
  const [justifications, setJustifications] = useState([]);
  const [disableButtons, setDisableButtons] = useState(false);

  useEffect(() => {
    loadComponentData();
  }, []);

  const loadComponentData = async () => {
    try {
      const _justifications = await fetchSuggestionsJustifications();
      setJustifications(_justifications);
    } catch (error) {
      console.error(error);
    }
  }

  const confirm = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setDisableButtons(true);

    recusa(idPedido, observacao, justification, 0, true, refusalAwareness);

    setTimeout(() => {
      setDisableButtons(false);
    }, 2000);
  }

  return (
    <div className="negotiation-volume">
      <div className="negotiation-line-volume-justification">
        <SelectBox
          name="justification"
          label={intl.get("commons.justification")}
          placeholder={intl.get("commons.justification")}
          valueKey='Key'
          labelKey='Value'
          value={justification}
          options={justifications}
          onChange={(value: IJustification) => setJustification(value.Key)}
          data-testid='selectbox-justification'
        />
      </div>
      <div className="negotiation-line-volume-justification">
        <TextArea
          id="observacao"
          label={intl.get('manual-suggestion-order-form.observation')}
          value={observacao|| ''}
          onChange={ev => setObservacao(ev.target.value)}
        />
      </div>
      <div className="negotiation-line-volume-actions">
        <Button
          value={intl.get('geral.buttonsDefault.close')}
          onClick={handleCancel}
          buttonType="default"
          className="button"
          disabled={disableButtons}
        />
        <Button
          value={intl.get('geral.buttonsDefault.confirm')}
          onClick={e => confirm(e)}
          buttonType="primary"
          className="button"
          disabled={disableButtons}
        />
      </div>
    </div>
  );
}

export default RecusaFornecedor;
